/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-03-30 17:11:01
 * @FilePath: /vise/packages/app-share/src/composable/use-initialize-home-data/use-init-ssr.ts
 */
import { useSSRContext } from 'vue';
import { IS_SSR } from '@/utils/env';
import type { InitializeHomeResult } from '@/server/initialize-home-data';
import { useStore, MutationTypes } from '@/store';

export default function useInitializeInSsr() {
  const store = useStore();
  // 定义服务端初始化 homeData数据的方法(把服务端拿到的数据透传至state)
  return () => {
    if (!IS_SSR) return;
    let homeData: undefined|InitializeHomeResult = undefined;
    ({ initState: homeData } = useSSRContext() || { homeData: null });

    if (homeData) {
      // 设置feedsList
      store.commit(
        MutationTypes.SET_FEEDS_LIST,
        { value: homeData.feedsList },
      );
      // 设置activeIndex
      store.commit(
        MutationTypes.SET_ACTIVE_INDEX,
        { value: homeData.activeIndex },
      );
      // 设置isCollection
      store.commit(
        MutationTypes.SET_IS_COLLECTION,
        { value: homeData.isCollection },
      );
      // 设置collectionInfo
      store.commit(
        MutationTypes.SET_COLLECTION_INFO,
        { value: homeData.collectionInfo },
      );
      // 设置showCollection
      store.commit(
        MutationTypes.SET_SHOW_COLLECTION,
        { value: !!homeData.isCollection },
      );
      // 设置isDrama
      store.commit(
        MutationTypes.SET_IS_DRAMA,
        { value: homeData.isDrama },
      );
      // 设置banner
      store.commit(
        MutationTypes.SET_BANNER,
        { value: homeData.banner },
      );
    }
  };
}
